import React from "react";
import "./subadminedit.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SubAdminEditForm from "./SubAdminEditForm";
import Topbar from "../../Global/topbar";

export default function SubAdminEdit() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { data, edit2 } = state || {};
  return (
    <div className="admin-main">
      <div className="admin-container">
        <Topbar />
        <div className="admin-mid4">
          <div className="backbutton">
            {" "}
            <button
              onClick={() => {
                navigate("/admin/sub_admin");
              }}
              className="logout"
            >
              {" "}
              <ArrowBackIcon style={{ fontSize: "2rem" }} />
            </button>{" "}
            <h1>Sub Admin Detail</h1>
          </div>
          <div className="link-admin">
            <Link href="" style={{ display: "none" }}>
              Dashboard
            </Link>{" "}
            <Link to="/admin/sub_admin">Sub Admin List</Link> &#62;{" "}
            <a href={window.location.href}>Sub Admin Detail</a>
          </div>
        </div>
        <SubAdminEditForm data={data} edit2={edit2} />
      </div>
    </div>
  );
}
